import styles from './CreateWorkspace.module.scss'

export default function CreateWorkspaceInlineInput({
  value,
  onChange,
  placeholder,
  inputClassName,
  rowClassName,
  ariaLabel,
}) {
  return (
    <label className={`${styles.inlineRow} ${rowClassName ?? ''}`.trim()}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className={`${styles.inlineInput} ${inputClassName ?? ''}`.trim()}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  )
}
